/* eslint-disable react-hooks/exhaustive-deps */
import { AxiosPromise, AxiosRequestConfig } from 'axios';
import { useCallback, useEffect, useRef } from 'react';
import {
  AllFacets,
  LogChartParams,
  LogData,
  LogFacetParams,
  LogParams,
  VaReportParams,
  VirusLinks,
  VirusLinksParams,
} from 'src/types/log';

import request from '@Utils/request';

function getRawLog(
  params: LogParams,
  config?: AxiosRequestConfig
): AxiosPromise<LogData> {
  return request({
    url: `log/contentList`,
    method: 'get',
    params,
    ...config,
  });
}

function getAllLog(params: LogParams): AxiosPromise<LogData> {
  return request({
    url: `log/exportLog`,
    method: 'get',
    params,
  });
}

function getRawFacets(
  params: LogFacetParams,
  config?: AxiosRequestConfig
): AxiosPromise<AllFacets> {
  return request({
    url: `log/facetList`,
    method: 'get',
    params,
    ...config,
  });
}

function getAutoComplete(
  params: LogFacetParams,
  config: AxiosRequestConfig
): AxiosPromise<AllFacets> {
  return request({
    url: `log/autoComplete`,
    method: 'get',
    params,
    ...config,
  });
}

function useEventCallback(fn: Function, dependence: any[]) {
  const ref = useRef(fn);
  useEffect(() => {
    ref.current = fn;
  }, [fn, ...dependence]);
  return useCallback(() => {
    if (ref.current) {
      ref.current();
    }
  }, []);
}

async function getVirusLink(params: VirusLinksParams): Promise<VirusLinks> {
  const virusLinks = (
    await request({
      url: `log/virusLink`,
      method: 'get',
      params,
    })
  ).data;
  return virusLinks;
}

function getSummaryReport(params: VaReportParams) {
  return request({
    url: `log/vaReport`,
    method: 'get',
    params,
  });
}

function getLogChartData(params: LogChartParams): AxiosPromise<any[]> {
  return request({
    url: `log/visualization`,
    method: 'get',
    params,
  });
}

export default {
  getRawLog,
  getAllLog,
  getRawFacets,
  getAutoComplete,
  useEventCallback,
  getSummaryReport,
  getLogChartData,
  getVirusLink,
};
